import { FC } from 'react';

import { Text } from '@hh.ru/magritte-ui';

import { DOT, NON_BREAKING_SPACE, REGULAR_SPACE } from 'src/utils/constants/symbols';

const Divider: FC = () => {
    return (
        <>
            {NON_BREAKING_SPACE}
            {NON_BREAKING_SPACE}
            <Text Element="span" typography="label-3-regular" style="secondary">
                {DOT}
            </Text>
            {NON_BREAKING_SPACE}
            {REGULAR_SPACE}
        </>
    );
};

export default Divider;
